import { useEffect } from 'react';

type Props = {
  children: React.ReactNode;
};

const AppWrapper = ({ children }: Props) => {
  useEffect(() => {
    const handleResize = () => {};
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window?.innerWidth]);

  return <>{children}</>;
};

export default AppWrapper;
